import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const cityApi = createApi({
  reducerPath: 'cityApi',
  baseQuery: axiosBaseQuerySpotfinder({   baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,}),
  tagTypes: ['city'],
  endpoints: builder => ({
    getAllCities: builder.mutation({
      query: body => {
        return {
            url: spotFinder.cityController.getAllCities,
            method: 'POST',
            body: body.payload,
            headers: body.token
                ? { Authorization: `Bearer ${body.token}` }
                : {}
        };
      },
    }),
  }),
});


export const {useGetAllCitiesMutation} = cityApi;
